// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"237": "c0748189","354": "da8c87d8","535": "bee4b14d","671": "4fa25dc4","687": "3585dea4","98": "8b729dad",}[chunkId] + ".js"
}